import React from 'react';
import styled from 'styled-components';
import { v4 as uuidv4 } from 'uuid';
import { ThemeProvider, createGlobalStyle } from 'styled-components';
import { Routes } from './Routes';
import { theme } from '../styling/theme';
import { UserId } from '../containers/UserId';
import { reset, global } from '../styling/css';
import { Console } from '../containers/Console';

const GlobalStyle = createGlobalStyle`
    ${reset}
    ${global}
`;

const StyledLogs = styled.div`
    position: absolute;
    top: 0;
    width: 100%;
    height: 100px;
    overflow: auto;
    z-index: 3;
    background-color: white;
`;

const Logs = () => {
    const { logs } = Console.useContainer();
    console.log({ logs });
    return (
        <StyledLogs>
            {logs.map((log, idx) => (
                <pre key={idx}>{log}</pre>
            ))}
        </StyledLogs>
    );
};

export const App = () => {
    const { userId, setUserId } = UserId.useContainer();

    // Generate a new id for this device
    React.useEffect(() => {
        if (!userId) {
            const newUserId = uuidv4();
            setUserId(newUserId);
        }
    }, [userId, setUserId]);

    return (
        <ThemeProvider theme={theme}>
            {/*<Logs />*/}
            <GlobalStyle />
            <Routes />
        </ThemeProvider>
    );
};

